import React from "react";

const stylePalette = { md: "", lg: "", xl: "page-title" };

const Typography = ({ className, children }) => {
  return (
    <div className={className}>
      <p>{children}</p>
    </div>
  );
};

export default Typography;
